/* tinyme-preview-resume.js
   ------------------------------------------------------------
   プレビュー保存・再開の共通ロジック（wimp / nyugaku1 / bd2 共通）

   - モーダルを閉じた時点のプレビュー情報を localStorage に自動保存する
     （ユーザーが明示的に「保存」操作をする必要はない）
   - 保存から7日以内であれば、画面下部のフローティングバナーで
     「続きから注文する」導線を表示する
   - 本（book_slug）ごとに1件のみ保持し、新しいプレビューを保存すると
     古いものは上書きされる
   ------------------------------------------------------------ */
(function () {
  if (window.TinyMePreviewResume) return; // 多重読み込み防止

  const STORAGE_PREFIX = 'tinyme_preview_';
  const EXPIRY_MS = 7 * 24 * 60 * 60 * 1000; // 7日間
  const STATUS_URL = 'https://lyskvdawy5qlnhqmzhpskyazoe0zweyb.lambda-url.ap-northeast-1.on.aws/';

  function storageKey(bookSlug) {
    return `${STORAGE_PREFIX}${bookSlug}`;
  }

  /** 保存する。jobId が無い場合は何もしない */
  function save(bookSlug, payload) {
    if (!bookSlug || !payload || !payload.jobId) return;
    try {
      const record = { ...payload, bookSlug, savedAt: Date.now() };
      localStorage.setItem(storageKey(bookSlug), JSON.stringify(record));
    } catch (e) {
      console.warn('[TinyMePreviewResume] save failed:', e);
    }
  }

  /** 有効期限内の保存データを取得。期限切れなら破棄して null を返す */
  function load(bookSlug) {
    if (!bookSlug) return null;
    try {
      const raw = localStorage.getItem(storageKey(bookSlug));
      if (!raw) return null;
      const record = JSON.parse(raw);
      if (!record.savedAt || Date.now() - record.savedAt > EXPIRY_MS) {
        localStorage.removeItem(storageKey(bookSlug));
        return null;
      }
      return record;
    } catch (e) {
      console.warn('[TinyMePreviewResume] load failed:', e);
      return null;
    }
  }

  function clear(bookSlug) {
    if (!bookSlug) return;
    try {
      localStorage.removeItem(storageKey(bookSlug));
    } catch (e) {
      /* noop */
    }
  }

  /** status_handler から最新の画像URL・book_meta を再取得する */
  async function fetchFreshStatus(jobId) {
    try {
      const r = await fetch(`${STATUS_URL}?preview_job_id=${encodeURIComponent(jobId)}`);
      const data = await r.json();
      if (data.status === 'done' && data.image_url) return data;
    } catch (e) {
      console.warn('[TinyMePreviewResume] status fetch failed:', e);
    }
    return null;
  }

  function hideBanner() {
    const el = document.getElementById('tinyme-resume-banner');
    if (el) el.remove();
  }

  /** 画面下部に「続きから注文する」フローティングバナーを表示する */
  function showBanner({ bookSlug, imageUrl, onResume }) {
    if (document.getElementById('tinyme-resume-banner')) return; // 二重表示防止

    if (!document.getElementById('tinyme-resume-banner-style')) {
      const style = document.createElement('style');
      style.id = 'tinyme-resume-banner-style';
      style.textContent = `
        @keyframes tinyme-resume-slide-up {
          from { transform: translateY(100%); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }

    const banner = document.createElement('div');
    banner.id = 'tinyme-resume-banner';
    banner.style.cssText = `
      position: fixed;
      left: 0; right: 0; bottom: 0;
      z-index: 9990;
      background: #fff;
      box-shadow: 0 -2px 12px rgba(0,0,0,0.15);
      padding: 0.75rem 1rem calc(0.75rem + env(safe-area-inset-bottom, 0px));
      display: flex;
      align-items: center;
      gap: 0.75rem;
      animation: tinyme-resume-slide-up 0.3s ease;
    `;

    banner.innerHTML = `
      <img src="${imageUrl}" alt="保存したプレビュー"
           style="width:48px;height:48px;object-fit:cover;border-radius:0.5rem;flex-shrink:0;">
      <div style="flex:1;min-width:0;">
        <p style="margin:0;font-size:0.9rem;font-weight:bold;color:#111;">保存したプレビューがあります</p>
        <p style="margin:0;font-size:0.78rem;color:#6b7280;">続きから注文に進めます</p>
      </div>
      <button type="button" data-resume
              style="background:#111;color:#fff;border:none;border-radius:9999px;
                     padding:0.6rem 1rem;font-size:0.85rem;font-weight:bold;
                     cursor:pointer;white-space:nowrap;flex-shrink:0;">
        続きから注文する
      </button>
      <button type="button" data-dismiss aria-label="閉じる"
              style="background:none;border:none;color:#9ca3af;font-size:1.3rem;
                     cursor:pointer;line-height:1;flex-shrink:0;padding:0 0.25rem;">
        ×
      </button>
    `;

    banner.querySelector('[data-resume]').addEventListener('click', () => {
      hideBanner();
      onResume?.();
    });
    banner.querySelector('[data-dismiss]').addEventListener('click', hideBanner);

    document.body.appendChild(banner);
  }

  window.TinyMePreviewResume = { save, load, clear, showBanner, hideBanner, fetchFreshStatus };
})();
